module.exports = __webpack_public_path__ + "static/img/demo-5.b674e37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/demo-5.png
// module id = ZmlU
// module chunks = 1